import { fetchNaniexpert } from "@/apis/naniexpert/base";
import type {
  GenerateContentByParamsRequest,
  GenerateContentResponse,
  GenerateContentSearchRequest,
  GenerateContentSearchResponse,
} from "@/types/apis/naniexpert";

export const generateContentByParams = (
  body: GenerateContentByParamsRequest
): Promise<GenerateContentResponse> =>
  fetchNaniexpert<GenerateContentResponse>({
    url: "/ailiteracy/gemini-3-flash-preview/generate-content",
    method: "POST",
    body,
  });

export const generateContentSearch = (
  body: GenerateContentSearchRequest
): Promise<GenerateContentSearchResponse> =>
  fetchNaniexpert<GenerateContentSearchResponse>({
    url: "/ailiteracy/gemini-3-flash-preview/generate-content/search",
    method: "POST",
    body,
  });
